import React from "react";

import { Navbar, Nav, NavItem } from "reactstrap";
import Moment from "react-moment";

const Footer = () => {
  return (
    <Navbar>
      <Nav navbar>
        <NavItem>
          © <Moment format="YYYY">{new Date()}</Moment> Zocial.
        </NavItem>
      </Nav>
    </Navbar>
  );
};

export default Footer;
